import * as React from 'react';

/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * Based on chakra-ui
 * https://github.com/chakra-ui/chakra-ui/blob/main/packages/react-utils/src/children.ts
 */

export function getValidChildren(children: React.ReactNode): React.ReactElement[] {
    return React.Children.toArray(children).filter((child) =>
        React.isValidElement(child)
    ) as React.ReactElement[];
}
